import React, { useState } from 'react'
import { Typography, Image, Table } from 'antd';
import codeImg from "../../img/code.png"
const { Title, Paragraph, Text } = Typography;

export default function Contact() {
  return (
    <Typography>      
      <Title level={4}>更多信息及联系购买请关注微信公众号</Title>
      <Paragraph>
      <Image width={800} src={codeImg} />
      </Paragraph>
    </Typography>
  )
}
